import { FormContainer } from 'components';
import { useTranslation } from 'libs/i18n';

import {
  CompanyActivityFormType,
  FormErrors,
  getSchema,
} from '../../forms/companyActivityForm';

import { FormContent, FormContentProps } from './FormContent';

interface Props extends FormContentProps {
  initialValues?: CompanyActivityFormType;
  onSubmit: (values: CompanyActivityFormType) => void;
  canGoBack?: boolean;
  onGoBack?: () => void;
  formError?: FormErrors;
  submitLoading?: boolean;
}

export const CompanyActivity = ({
  initialValues,
  canGoBack,
  onGoBack,
  submitLoading,
  formError,
  onSubmit,
  ...formProps
}: Props) => {
  const { t } = useTranslation();
  const schema = getSchema();
  return (
    <FormContainer
      canGoBack={canGoBack}
      initialErrors={formError}
      initialValues={initialValues}
      submitLoading={submitLoading}
      subTitle={t('onboarding.companyActivity.subtitle')}
      title={t('onboarding.companyActivity.title')}
      validationSchema={schema}
      onGoBack={onGoBack}
      onSubmit={onSubmit}
    >
      <FormContent {...formProps} />
    </FormContainer>
  );
};
